import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8h4l3mg9te: FaireBrandEntity = {
  token: "b_8h4l3mg9te",
  type: "brand",
  name: "Bari Olive Oil",
  avatarUrl:
    "https://cdn.faire.com/fastly/790666d96da04425e35b96e66a17ecfff8d4627c4d27f507d633753ca4eb4b1b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3ea22c2f106318a874bf400ee5d20557726a1dc4f0f3f96cc1955cd9f8e01348.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/790666d96da04425e35b96e66a17ecfff8d4627c4d27f507d633753ca4eb4b1b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3ea22c2f106318a874bf400ee5d20557726a1dc4f0f3f96cc1955cd9f8e01348.jpeg",
  location: "Dinuba, CA, USA",
  minimumOrderDollars: 83,
  rating: 4.8,
  reviewCount: 8,
  isInsider: true,
  description:
    "With roots back to 1936, Bari is one of the oldest olive oil companies in the United States. Our founders were born in Bari, Italy and chose the name out of honor and respect for the homeland. Now, as fifth-generation family farmers, Bari continues the family tradition. Many of the olives used to create our high quality extra virgin olive oil are grown on our own family olive groves. The other olives are sourced from other local family farms to ensure quality and freshness. We are indeed proud that every drop of olive oil we produce is first-press, cold-press extra virgin olive oil.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:27.484Z",
    importedBy: "entity-db-cli",
  },
};
